import angular from 'angular'
import comprehensiveIncomeTax from './comprehensiveIncomeTax'
import parameterConfiguration from './parameterConfiguration'
import declarationTaskTracking from './declarationTaskTracking'
import refundServiceChargeTaskTracking from './refundServiceChargeTaskTracking'
// import operationLog from './operationLog'

export default angular
  .module('declaration.personalIncomeTax', [
    comprehensiveIncomeTax,
    parameterConfiguration,
    declarationTaskTracking,
    refundServiceChargeTaskTracking,
    // operationLog,
  ])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      $stateProvider.state('declaration.personalIncomeTax', {
        abstract: true,
        url: '/personalIncomeTax',
        template: '<div ui-view></div>',
        title: '个人所得税',
      })
    },
  ]).name



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/index.js